import styled from 'styled-components';
import BannerBG from 'common/src/assets/image/saasModern/banner-texture.png';
import BannerBGNew from 'common/src/assets/image/saasModern/banner-texture-new.png';
import BannerBGNew1 from 'common/src/assets/image/saasModern/banner-texture-new-1.png';
import BannerBGNew2 from 'common/src/assets/image/saasModern/banner-texture-new-2.png';
import BannerBGNew3 from 'common/src/assets/image/saasModern/banner-texture-new-3.png';
import BannerBGNew4 from 'common/src/assets/image/saasModern/banner-texture-new-4.png';

export const BannerWrapper = styled.section`
  padding: 150px 0 50px 0;
  background-image: url(${BannerBGNew4}),
  /* linear-gradient(30deg,rgb(83, 199, 215) 25%,rgb(111, 134, 244) 100%); */
  linear-gradient(132deg,#00a4fe 25%,#27b1f2 50%);
  background-size: cover;
  background-position: top center;
  @media (max-width: 575px) {
    padding: 120px 0 0 0;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

export const DiscountWrapper = styled.div`
  /* text-align: center; */
`;

export const DiscountLabel = styled.div`
  font-family: 'Open Sans', sans-serif;
  display: inline-block;
  border-radius: 4em;
  padding: 9px 22px;
  margin-bottom: 22px;
  background-color: rgba(255, 255, 255, 0.15);
  @media (max-width: 575px) {
    padding: 7px 10px;
  }
`;

export const PhoneSmall = styled.div`
  display: flex;
  align-items: center;
  border-radius: 38px;
  background: #fff;
  box-shadow: inset 0 4px 7px 1px #fff, inset 0 -5px 20px rgba(173,186,204,.25), 0 2px 6px rgba(0,21,64,.14), 0 10px 20px rgba(0,21,64,.05);
  order: 0;
  margin: 50px 50px 0 0;
  padding: 0px 3px;

  width: 225px;
  height: 467px;
`;

export const PhoneBig = styled.div`
  display: flex;
  align-items: center;
  border-radius: 38px;
  background: #fff;
  box-shadow: inset 0 4px 7px 1px #fff, inset 0 -5px 20px rgba(173,186,204,.25), 0 2px 6px rgba(0,21,64,.14), 0 10px 20px rgba(0,21,64,.05);
  order: 0;
  margin: 50px 50px 0 0;
  padding: 0px 3px;

  width: 267px;
  height: 553px;
`;

export const TabletLandscape = styled.div`
  display: flex;
  align-items: center;
  border-radius: 38px;
  background: #fff;
  box-shadow: inset 0 4px 7px 1px #fff, inset 0 -5px 20px rgba(173,186,204,.25), 0 2px 6px rgba(0,21,64,.14), 0 10px 20px rgba(0,21,64,.05);
  order: 0;
  margin: 50px 50px 0 0;
  padding: 0px 3px;

  width: 512px;
  height: 352px;
`;

export const BannerImage = styled.div`
  /* background-color: red; */
  display: flex;
  position: absolute;
  transform: rotate(-11deg);
  top: -50px;

  @media (max-width: 992px) {
    display: none;
    /* background-color: red; */
    /* background-color: red; */
    /* max-width: 750px;
    width: 100%; */
  }
  /* @media (min-width: 992px) {
    background-color: blue;
  }
  @media (min-width: 1220px) {
    background-color: green;
  }
  @media (max-width: 768px) {
    background-color: beige;
  } */

`;